<template>
  <div>
    <my-loader v-if="isLoading" />

    <div v-else class="content">
      <div class="create-button">
        <my-shrunk-button
          class="create-btn"
          :btnSettings="{ shrunk: true, name: 'fa-square-plus' }"
          @click="show = !show"
        >
          {{ show ? 'К списку' : 'Создать' }}
        </my-shrunk-button>
      </div>

      <CustomerForm v-if="show" @sendForm="createCustomer" />

      <div v-else class="table-page">
        <div class="list-content">
          <h2>Список клиентов</h2>

          <div v-if="hasError" class="state-block error-block">
            Не удалось загрузить список заказчиков. Попробуйте обновить страницу.
            <button class="retry-btn" type="button" @click="loadPage(currentPage)">
              Повторить
            </button>
          </div>

          <div v-else-if="!customers.length" class="state-block">
            Заказчиков пока нет.
          </div>

          <table v-else class="company-table">
            <thead>
              <tr>
                <th>Название</th>
                <th>ИНН</th>
                <th>Руководитель</th>
                <th>Телефон</th>
                <th>Почта</th>
                <th>Юр. адрес</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="customer in customers"
                :key="customer.id"
                class="row-company"
                @click="$router.push(`/customers/${customer.id}`)"
              >
                <td>{{ customer.name || '—' }}</td>
                <td>{{ customer.inn || '—' }}</td>
                <td>{{ customer.director || '—' }}</td>
                <td>{{ customer.phone || '—' }}</td>
                <td>{{ customer.email || '—' }}</td>
                <td>{{ customer.address || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <my-pagination
        v-if="!show && !hasError && totalPages > 1"
        :currentPage="currentPage"
        :totalPages="totalPages"
        @pageChanged="pageChanged"
      />
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import CustomerForm from '@/components/forms/CustomerForm'
import {
  customerCreateSucceeded,
  normalizeCustomersItems,
  shouldShowCustomersListLoader,
} from '@/pages/customer/customerState.mjs'

export default {
  name: 'CustomerList',
  components: {
    CustomerForm,
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const show = ref(false)
    const hasError = ref(false)
    const creating = ref(false)

    const loadPage = async (page = 1) => {
      hasError.value = false
      const ok = await store.dispatch('apiStorage/getItems', {
        model: 'customers',
        params: { page },
      })
      hasError.value = !ok
    }

    onMounted(() => {
      loadPage(1)
    })

    const createCustomer = async (data) => {
      creating.value = true
      try {
        const created = await store.dispatch('apiStorage/addItem', data)
        if (customerCreateSucceeded(created)) {
          show.value = false
          await router.push(`/customers/${created.id}`)
        }
      } finally {
        creating.value = false
      }
    }

    const pageChanged = (page) => {
      loadPage(page)
    }

    return {
      show,
      hasError,
      loadPage,
      totalPages: computed(() => store.state.apiStorage.customers.totalPages || 1),
      currentPage: computed(() => store.state.apiStorage.customers.currentPage || 1),
      customers: computed(() =>
        normalizeCustomersItems(store.state.apiStorage.customers.items),
      ),
      pageChanged,
      isLoading: computed(() =>
        shouldShowCustomersListLoader({
          statusLoading: store.state.apiStorage.customers.statusLoading,
          showCreateForm: show.value,
          creating: creating.value,
        }),
      ),
      createCustomer,
    }
  },
}
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.list-content h2 {
  padding: 20px;
  text-align: center;
}

.company-table {
  margin-left: 20px;
  margin-right: 20px;
  border-collapse: collapse;
}

.company-table th,
.company-table td {
  text-align: center;
  padding: 10px;
  border: 1px solid #ccc;
}

.company-table th {
  font-weight: bold;
}

.row-company:hover {
  background-color: rgba(224, 187, 72, 0.4);
  cursor: pointer;
}

.create-button {
  width: 100%;
  margin-left: 20px;
  margin-top: 20px;
}

.state-block {
  padding: 24px;
  color: #667085;
  font-size: 14px;
  text-align: center;
}

.error-block {
  color: #c0392b;
}

.retry-btn {
  display: block;
  margin: 12px auto 0;
  padding: 6px 12px;
  border: 1px solid #c0392b;
  border-radius: 4px;
  background: #fff;
  color: #c0392b;
  cursor: pointer;
}
</style>
